import { useEffect, useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';
import { ErrorToast } from '../../../utils/toasters';
import { CompanyService } from '../../company/CompanyService';
import SingleSelectDropdown from '../../../shared/components/SingleSelectDropdown';

interface IIncomingDeferralFilter {
    handleState: (...arg: any) => void;
    setState: (...arg: any) => void;
    offersFilter: any;
}

export function OutgoingInvoicesFilter({ handleState, setState, offersFilter }: IIncomingDeferralFilter) {
    const currentYear = new Date().getFullYear();
    const startYear = 2017;
    const endYear = 2040;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    const [companyFilter, setCompanyFilter] = useState('');
    const [companyDropdown, setCompanyDropdown] = useState<any[]>([]);
    useEffect(() => {
        CompanyService.getCompanies({ displayNameOrId: companyFilter })
            .then(data => {
                setCompanyDropdown(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [companyFilter]);

    function handleChanges(evt: React.ChangeEvent<HTMLSelectElement>) {
        const { name, value } = evt.target;
        let parsedValue: string | boolean | undefined = value;
        if (value === 'true') parsedValue = true;
        else if (value === 'null') parsedValue = false;
        else if (value === 'undefined') parsedValue = undefined;
        setState({
            ...offersFilter,
            [name]: parsedValue || currentYear,
            page: 1,
        });
    }
    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-3 col-6">
                    <AutocompleteInput
                        placeholder="Company name or ID"
                        onSelect={company => {
                            setState({
                                ...offersFilter,
                                companyId: company.id,
                                page: 1,
                            });
                        }}
                        setFilter={setCompanyFilter}
                        value={companyFilter}
                        items={companyDropdown}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                companyId: undefined,
                                page: 1,
                            });
                            setCompanyFilter('');
                        }}
                    />
                </div>
                <div className="col-md-3 col-6">
                    <SingleSelectDropdown
                        placeholder="Year"
                        options={years.map(year => ({ value: String(year), label: String(year) }))}
                        selected={String(offersFilter?.year || currentYear)}
                        clearable={Number(offersFilter?.year || currentYear) !== currentYear}
                        active={Number(offersFilter?.year || currentYear) !== currentYear}
                        onChange={value => handleChanges({ target: { name: 'year', value } } as any)}
                    />
                </div>
            </Row>
            <Button className="mt-4" onClick={() => handleState(offersFilter)}>
                Search
            </Button>
        </Form>
    );
}
